import { createSlotRecipe } from './runtime.js';

const tabsConfig = {"name":"tabs","slots":["root","listWrapper","list","thumb","fade","trigger","content","icon","text"],"defaultVariants":{"showLine":true,"type":"scroll"},"variantMap":{"showLine":["false","true"],"type":["scroll","stretch"]}}

export const tabs = /* @__PURE__ */ createSlotRecipe(tabsConfig)